export const wrapperClassName = 'dapp-core-ui-component';
export default wrapperClassName;
